import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable} from 'rxjs';
import {Router} from '@angular/router'
import { AuthService } from '../../services/auth/auth.service';

@Injectable({
  providedIn: 'root'
})
export class CheckTFAGuard  {
  constructor(
    private auth:AuthService,
    private router: Router,
  ) {  }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    if(this.auth.userDetail() && this.auth.userDetail()?.isTfaConfigured !== undefined && !this.auth.userDetail()?.isTfaConfigured){
      return true;
    }
    this.router.navigate(['/']);
    return false;
  }

}
